import React from "react";
import { User, IdCard, Bell, Globe2, LogOut } from "lucide-react";
import SettingsItem from "./SettingsItem";

export default function SettingsList({
  onProfile,
  onPatientSetup,
  onNotifications,
  onLanguage,
  onLogout,
}) {
  return (
    <section className="p2-settings-list">
      <h2 className="p2-settings-list-title">
        Cilësimet e llogarisë
      </h2>

      <SettingsItem
        icon={User}
        title="Profili im"
        subtitle="Emri, fotoja dhe informacioni bazë"
        onClick={onProfile}
      />

      <SettingsItem
        icon={IdCard}
        title="Të dhënat e pacientit"
        subtitle="Datëlindja, gjendja shëndetësore, kontakti emergjent"
        onClick={onPatientSetup}
      />

      <SettingsItem
        icon={Bell}
        title="Njoftimet"
        subtitle="E-mail, njoftime për takime dhe mesazhe"
        onClick={onNotifications}
      />

      <SettingsItem
        icon={Globe2}
        title="Gjuha & rajoni"
        subtitle="Gjuha e aplikacionit dhe zona kohore"
        onClick={onLanguage}
      />

      <div className="p2-settings-list-danger-wrapper">
        <SettingsItem
          icon={LogOut}
          title="Dil nga llogaria"
          subtitle="Shkyçu nga MikDok në këtë pajisje"
          tone="danger"
          onClick={onLogout}
        />
      </div>
    </section>
  );
}
